import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { SharedApiService, ApiType } from '../../../../../libs/shared/src/lib/services/api.service';

export interface SuggestionCompany {
  id: number;
  name: string;
  logo?: string | null;
}

export interface SearchSuggestions {
  titles: string[];
  companies: SuggestionCompany[];
}

interface SuggestionsResponse {
  titles: string[];
  companies: SuggestionCompany[];
}

@Injectable({
  providedIn: 'root',
})
export class SuggestionsService {
  constructor(private sharedApiService: SharedApiService) {}

  /**
   * Typeahead suggestions for the job search bar (matching job titles and
   * companies). Profession suggestions are computed client-side from the
   * localized position labels. Errors degrade to empty results so the search
   * bar never breaks on a failed suggestion call.
   */
  getSuggestions(query: string, limit = 5): Observable<SearchSuggestions> {
    const params = new HttpParams().set('q', query).set('limit', limit.toString());

    return this.sharedApiService
      .get<SuggestionsResponse>('api/suggestions', params, {
        apiType: ApiType.OPEN,
        jobsRequest: true,
      })
      .pipe(
        map((response) => ({
          titles: response.titles || [],
          companies: response.companies || [],
        })),
        catchError(() => of({ titles: [], companies: [] }))
      );
  }
}
